import React, { useEffect, useState } from 'react'
import '../ProductDetails/ProductDetails.css'
import { Row, Col } from 'react-bootstrap'
import likeicon from '../../assets/images/png/like-icon.png'
import wishlistSelectedIcon from '../../assets/images/png/wishlistSelectedIcon.png'
import ProductsReview from './ProductsReview'
import { useNavigate, useParams } from 'react-router-dom'
import { getProductDetails } from '../../services/ProductsServices'
import {
  addProductToCart,
  getProductsInCart
} from '../../services/CartServices'
import {
  addProducttoWishlist,
  getWishlistProducts
} from '../../services/WishlistServices'

const DetailsOfProducts = () => {
  const [selectedImage, setSelectedImage] = useState(0)
  const [details, setDetails] = useState([])
  const [favouriteItems, setFavouriteItems] = useState([])
  const [productQuantity, setProductQuantity] = useState(1)
  const navigate = useNavigate()
  const { id } = useParams()

  const getDetails = async () => {
    const res = await getProductDetails(id)
    console.log('getDetails---->', res)
    setDetails(res)
  }

  useEffect(() => {
    getDetails()
    getWishlistItems()
  }, [id])

  const addToCart = async id => {
    const tokenItem = localStorage.getItem('token')
    if (tokenItem) {
      const res = await getProductsInCart(tokenItem)
      const productIds = res?.map(product => product?.productId?._id)
      const productQuantityInCart = res?.map(product => product?.quantity)
      let quantity = productQuantity
      if (productIds && productQuantityInCart) {
        const index = productIds.indexOf(id)
        if (index !== -1) {
          quantity += productQuantityInCart[index]
        }
      }
      const response = await addProductToCart(id, quantity, tokenItem)
      navigate('/cart')
    } else {
      localStorage.setItem('path', `/product-details/${id}`)
      navigate('/signin')
    }
  }

  const updateQuantity = quantity => {
    if (quantity < 1) {
      quantity = 1
    }
    setProductQuantity(quantity)
  }

  const handleQuantityChange = e => {
    const quantity = parseInt(e.target.value)
    if (!isNaN(quantity)) {
      updateQuantity(quantity)
    }
  }

  const convertDate = x => {
    const d = new Date(x)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return d.toLocaleDateString('en-US', options)
  }

  const getWishlistItems = async () => {
    const tokenitem = localStorage.getItem('token')
    const res = await getWishlistProducts(tokenitem)
    setFavouriteItems(res)
  }

  const addToWishlist = async id => {
    const tokenitem = localStorage.getItem('token')
    if (tokenitem) {
      const productId = id
      await addProducttoWishlist(productId, tokenitem)
      getWishlistItems()
    } else {
      localStorage.setItem('path', `/product-details/${id}`)
      navigate('/signin')
    }
  }

  const isInWishlist = id => {
    return (
      favouriteItems && favouriteItems.some(item => item?.productId?._id === id)
    )
  }

  return (
    <div className='bg_clr_light_yellow pb-5 pt-4'>
      <div className='container'>
        <div className='bg-white p-4 rounded-2'>
          <Row className=''>
            <Col xl={6}>
              <Row className='align-items-stretch flex-column-reverse flex-sm-row h-100'>
                <div className='col-sm-2 ps-0'>
                  <div className='d-flex flex-sm-column justify-content-sm-between gap-3 gap-sm-0'>
                    {details?.productData?.images?.map((item, index) => (
                      <div
                        className={
                          selectedImage === index
                            ? 'product-img-border text-center py-1 mt-1'
                            : 'text-center py-1 mt-1'
                        }
                        onClick={() => setSelectedImage(index)}
                        key={index}
                      >
                        <img
                          className='seed-product-img mx-auto rounded-3 object-fit-contain py-2 cursor-pointer'
                          src={item}
                          alt={details?.productData?.name}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className='col-sm-10 product-div-border d-flex align-items-center justify-content-center position-relative py-2'>
                  <div className=''>
                    <img
                      className='main-product-img object-fit-contain py-5'
                      src={details?.productData?.images?.[selectedImage]}
                      alt=''
                    />
                  </div>
                  <div
                    onClick={() => addToWishlist(details?.productData?._id)}
                    className='position-absolute cursor-pointer bg_dark_white wishlistIcon-div d-flex align-items-center justify-content-center'
                  >
                    {isInWishlist(details?.productData?._id) ? (
                      <img
                        className='postion-relative z-3'
                        width={18}
                        src={wishlistSelectedIcon}
                        alt='wishlistIcon'
                      />
                    ) : (
                      <img
                        className='postion-relative z-3'
                        width={18}
                        src={likeicon}
                        alt='wishlistIcon'
                      />
                    )}
                  </div>
                </div>
              </Row>
            </Col>
            <Col xl={6}>
              <div className='h-100 d-flex flex-column  justify-content-between'>
                <div>
                  <div className='bg_red agriculture-input-div py-1 px-3 mt-4 mt-xl-0'>
                    <p className='text-white ff_heebo fs_2xsm ls-03'>
                      {details?.productData?.productType === 'gaonSe'
                        ? 'Agriculture Output'
                        : ' Agriculture Input'}
                    </p>
                  </div>
                  <h2 className='clr_dark_blue ff_heebo fw-bold fs_3xl lh-36  pe-xl-5 me-xl-5 mt-3 text-capitalize'>
                    {details?.productData?.name}
                  </h2>
                  <div className='me-xl-2 mt-3'>
                    <p
                      className='ff_heebo fs_xsm clr_dark_grey_2 lh-26 pe-xl-5 me-xl-4'
                      dangerouslySetInnerHTML={{
                        __html: details?.productData?.sortDescription
                      }}
                    ></p>
                  </div>
                </div>
                <div className='d-flex align-items-start gap-3 flex-column'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <p className='ff_arial fw-bold fs_md mb-0 text-black'>
                      ₹{details?.productData?.discountPrice}
                      <span className='fs_4xsm fw-normal clr_dark_green'>
                        /
                        <span className='text-decoration-line-through'>
                          ₹ {details?.productData?.price}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div className='d-flex gap-3'>
                    <div className='d-flex align-items-center justify-content-center select-div-2 px-2 rounded-2'>
                      <button
                        onClick={() => updateQuantity(productQuantity - 1)}
                        className='bg-transparent border-0 ff_heebo pb-1'
                      >
                        -
                      </button>
                      <div className='ps-1'>
                        <p className='mb-0 clr_dark_blue_2 ff_heebo'>Qty:</p>
                      </div>
                      <input
                        className='select-option me-auto ps-1 ms-0 clr_dark_blue_2 ff_heebo text-center'
                        type='number'
                        value={productQuantity}
                        onChange={handleQuantityChange}
                        min='1'
                      />
                      <button
                        onClick={() => updateQuantity(productQuantity + 1)}
                        className='bg-transparent border-0 ff_heebo pb-1'
                      >
                        +
                      </button>
                    </div>
                    <button
                      onClick={() => addToCart(details?.productData?._id)}
                      style={{
                        width: '152px',
                        height: '40px',
                        paddingTop: '2px'
                      }}
                      className='common-darkgreen-button text-uppercase px-4 ff_heebo fw-medium text-white text-uppercase rounded-3 fs_xxsm'
                    >
                      add to cart
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='container mt-5'>
        <div className='bg-white p-4 rounded-2'>
          <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
            description
          </h4>
          <div className='light-grey-hr-line w-100 position-relative '>
            <div className='green-hr-line green-hr-line-width'></div>
          </div>
          <p
            className='ff_heebo fs_xsm clr_dark_grey_2 lh-26 mt-4'
            dangerouslySetInnerHTML={{
              __html: details?.productData?.description
            }}
          ></p>
        </div>
      </div>
      <div className='container mt-5'>
        <div className='bg-white p-4 rounded-2'>
          <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
            Specification
          </h4>
          <div className='light-grey-hr-line w-100 position-relative '>
            <div className='green-hr-line green-hr-line-width'></div>
          </div>
          <div>
            <Row className='mt-4'>
              <Col xl={4}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Price:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      ₹{details?.productData?.discountPrice}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4 mt-xl-0' xl={4}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Seller Type:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0 text-capitalize'>
                      {details?.productData?.sellerType}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4 mt-xl-0' xl={4}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Published:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {convertDate(details?.productData?.createdAt)}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' xl={4}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Category:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0 text-capitalize'>
                      {details?.productData?.productType}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className='container'>
        <ProductsReview paddingTop={'pt-md-5'} />
      </div>
    </div>
  )
}

export default DetailsOfProducts
